export type messageType = JSX.Element | string;
export const noop: (message: messageType) => void = () => {};
export const message = {
    success: noop,
    error: noop,
    info: noop
};
export type alertType = keyof typeof message;

export interface SetAlertParams {
    message?: messageType;
    type?: alertType;
    active?: boolean;
    id: number;
}
